import type React from 'react';

export function onClickGenerator<E extends HTMLElement | SVGElement>(
  fn: (e: React.MouseEvent<E> | React.KeyboardEvent<E> | React.TouchEvent<E>) => void,
): {
  onClick: (e: React.MouseEvent<E>) => void;
  onKeyUp: (e: React.KeyboardEvent<E>) => void;
} {
  return {
    onClick: (e) => {
      e.preventDefault();
      fn(e);
    },
    onKeyUp: (e) => {
      if (e.key === 'Enter') {
        fn(e);
      }
    },
  };
}
